import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme.js';

import { openSearch } from '../../actions/search';

import CompanyLogo from '../CompanyLogo';
import ContentContainer from '../ContentContainer';
import Paragraph from '../Paragraph';
import HeaderNavigation from '../HeaderNavigation';
import BurgerMenu from '../BurgerMenu';

export default class Header extends Component {
  _openSearch() {
    this.props.dispatch(openSearch());
  }

  render() {
    return (
      <div className={css(styles.container)}>
        <ContentContainer>
          <div className={css(styles.navigation_container)}>
            <CompanyLogo />
            <HeaderNavigation openSearch={this._openSearch.bind(this)} showSearch={this.props.content && this.props.content.loaded} />
          </div>
          <div className={css(styles.mobile_navigation_container)}>
            <CompanyLogo />
            <div className={css(styles.burger_menu_container)}>
              <BurgerMenu />
            </div>
          </div>
        </ContentContainer>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    flexDiection: 'row',
    width: '100vw',
    height: Theme.navigation.height,
    zIndex: Theme.navigation.zIndex,
    backgroundColor: Theme.white,
    alignItems: 'center',
    [Theme.mobile_query]: {
      boxSizing: 'border-box',
      padding: 15,
    },
  },
  navigation_container: {
    display: 'flex',
    flexDiection: 'row',
    alignItems: 'center',
    [Theme.mobile_query]: {
      display: 'none',
    }
  },
  mobile_navigation_container: {
    display: 'none',
    [Theme.mobile_query]: {
      display: 'flex',
      flexDiection: 'row',
      alignItems: 'center',
    }
  },
  burger_menu_container: {
    position: 'fixed',
    top: 0,
    left: 0,
    alignItems: 'flex-end',
  },
})



// WEBPACK FOOTER //
// ./src/components/Header/index.js